import React from "react";

const normalizeSite = (site) => {
  if (typeof site === "string") {
    return {
      name: site || "Unnamed site",
      code: site || "SITE",
      status: "Active",
    };
  }

  return {
    name: site?.name || site?.site || site?.label || site?.code || "Unnamed site",
    code: site?.code || site?.id || site?.name || "SITE",
    status: site?.status || (site?.active === false ? "Inactive" : "Active"),
  };
};

export default function SiteMap({
  sites = [],
  selectedSite = "All Sites",
  onSiteClick,
  onSelectSite,
}) {
  const safeSites = Array.isArray(sites) ? sites.map(normalizeSite) : [];

  const handleClick = (site) => {
    if (onSiteClick) onSiteClick(site.name);
    if (onSelectSite) onSelectSite(site.name);
  };

  return (
    <div data-testid="authoritative-site-map">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        {safeSites.map((site, index) => {
          const isSelected = selectedSite === site.name;
          return (
            <button
              key={`${site.code}-${index}`}
              onClick={() => handleClick(site)}
              className={`rounded-xl border px-4 py-4 text-center transition-all ${
                isSelected
                  ? "bg-green-100 border-green-500 ring-2 ring-green-200"
                  : "bg-green-50 border-green-300 hover:bg-green-100"
              }`}
            >
              <div className="font-bold text-green-800 text-sm">{site.name}</div>
              <div className="text-[11px] text-green-700 mt-1">0 · 0</div>
            </button>
          );
        })}
        {safeSites.length === 0 && (
          <div className="sm:col-span-2 md:col-span-3 lg:col-span-6 rounded-xl border border-dashed border-slate-200 px-4 py-8 text-center text-sm text-slate-400">
            No sites are available in the current authorized filter scope.
          </div>
        )}
      </div>
    </div>
  );
}
